import React from "react"
import styled from "styled-components"
import ValidIcon from "../../images/icons/valid.svg"
import { CheckItemText } from "../../theme/Typography"
import Colors from "../../theme/Colors"
import { onDesktop, onPhone, onTablet } from "../../theme/MediaQueries"

const Container = styled.div`
  display: flex;
  flex-direciton: row;
  align-items: center;
  ${onPhone} {
    margin: 4px 0;
  }
  ${onTablet} {
    margin: 8px 0;
  }
  ${onDesktop} {
    margin: 16px 0;
  }
`

const IconContainer = styled.div`
  width: 20px;
  height: 20px;
  background-color: ${Colors.lighterblue};
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 5px;
  ${onDesktop} {
    margin-right: 10px;
    width: 24px;
    height: 24px;
  }
`

const Icon = styled.img`
  margin: 0;
  width: 14px;
  height: 14px;
  ${onDesktop} {
    width: 20px;
    height: 20px;
  }
`
const Text = styled.div`
  ${CheckItemText};
  font-size: 14px;
  font-weight: 400;
  ${onDesktop} {
    font-size: 16px;
    font-weight: 700;
  }
`

const CheckItem = ({ children }) => (
  <Container>
    <IconContainer>
      <Icon src={ValidIcon} />
    </IconContainer>
    <Text>{children}</Text>
  </Container>
)

CheckItem.propTypes = {}

CheckItem.defaultProps = {}

export default CheckItem
